export default __webpack_public_path__ + "static/media/bg-depart.bf9cea17.svg";